import {
  getMotivoNome,
  getTipoServicoNome,
} from '../../utils/servicosFilters';

/** Labels alinhados ao formulário DefaultModal (Informações da NSMP). */
export const CAMPO_DIGITACAO_LABELS = {
  tipoServico: 'Tipo de serviço',
  motivo: 'Motivo',
  numLinhasPlanilha: 'N° linhas',
  quantidadePostes: 'Quantidade de postes',
  nsmpProgramada: 'N° NSMP programada',
  nsmp: 'N° NSMP nova',
  latitude: 'Latitude',
  longitude: 'Longitude',
  coordenada: 'Coordenada',
  observacaoDigitador: 'Observação do digitador',
};

const isEmptyValue = (value) =>
  value == null || String(value).trim() === '';

export const getCampoDigitacaoLabel = (campo) =>
  CAMPO_DIGITACAO_LABELS[campo] || campo;

export const formatAlteracaoValor = (campo, value) => {
  if (isEmptyValue(value)) return null;
  if (campo === 'tipoServico') return getTipoServicoNome(value) || value;
  if (campo === 'motivo') return getMotivoNome(value) || value;
  return String(value);
};

/**
 * Formata uma alteração para a timeline.
 * - Primeira digitação (de vazio): "Tipo de serviço: E-mail"
 * - Correção: "Tipo de serviço: Manutenção → Planilha"
 * - Limpeza: "Tipo de serviço: E-mail → (vazio)"
 */
export const formatAlteracaoLine = (alt) => {
  if (!alt?.campo) return null;
  const label = getCampoDigitacaoLabel(alt.campo);
  const de = formatAlteracaoValor(alt.campo, alt.de);
  const para = formatAlteracaoValor(alt.campo, alt.para);

  if (!de && para) return `${label}: ${para}`;
  if (de && !para) return `${label}: ${de} → (vazio)`;
  if (de && para) {
    if (de === para) return `${label}: ${para}`;
    return `${label}: ${de} → ${para}`;
  }
  return null;
};

export default formatAlteracaoLine;
